import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Product, fetchGetProducts, hasProduct } from "../../../../queries/products";
import { Products } from "../../../../constants/products";

const useProducts = () => {
  const dispatch = useDispatch();
  const params = useParams<{ site: string }>();
  const productsQuery = useQuery<{ data: Product[] }>(["products", params.site], fetchGetProducts(dispatch));

  const hasCrm = hasProduct(productsQuery, Products.CRM);
  const hasCe = hasProduct(productsQuery, Products.CE);
  const hasCommunications = hasProduct(productsQuery, Products.COMMUNICATIONS);
  const hasPermits = hasProduct(productsQuery, Products.PERMITS);

  return {
    hasCrm,
    hasCe,
    hasCommunications,
    hasPermits,
    productsQuery,
    isLoading: productsQuery.isLoading,
  };
};

export default useProducts;
